import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

// 🔑 Inject JWT from Zustand persist storage
api.interceptors.request.use((config) => {
  const raw = localStorage.getItem('auth-storage');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      const token = parsed?.state?.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (e) {
      console.warn('Failed to parse auth-storage');
    }
  }
  return config;
});

export default api;

